module.exports = __webpack_public_path__ + "img/HM.4569fff2.svg";